(function() { window.GUID_93ffefab_a014_43f6_b1f2_aec79ae4fb9b = { getGuid: function() { return "93ffefab-a014-43f6-b1f2-aec79ae4fb9b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class HorizontalBarChart {
            constructor() {
                this.id = CS.Helper.generateRandomId();
            }
        }
        Controls.HorizontalBarChart = HorizontalBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=HorizontalBarChart.js.map
